import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {
  public get isIosBrowser(): boolean {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
      // iPad on iOS 13 detection
      || (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
      || navigator.platform.toUpperCase().indexOf('MAC') >= 0
  }

  private get isFalseNative(): boolean {
    return [
      'SznProhlizec',
    ].includes(navigator.platform)
  }

  public get isNativePlatform(): boolean {
    if (this.isFalseNative) {
      return false;
    }
    return Capacitor.isNativePlatform();
  }
}
